import { UserRecordDto } from '@splitsecondconnect/ultramarine-shared';

import { UserRecordModel } from '../../modules/admin/users/models/user-record.model';
import { dateCast } from '../functions/sectionCasters.function';

import { mapBaseDtoToBaseModel, mapBaseModelToBaseDto } from './base.mapper';

export function mapUserDtoToModel(dto: UserRecordDto): UserRecordModel {
	return {
		...mapBaseDtoToBaseModel(dto),
		username: dto.username ?? null,
		email: dto.email ?? null,
		userRoleName: dto.userRoleName ?? null,
		status: dto.status ?? null,
		userRolePermissions: dto.userRolePermissions ?? null,
		lastLoginAt: dateCast(dto.lastLoginAt),
		lastLoginIp: dto.lastLoginIp ?? null,
		type: dto.type ?? null,
	};
}

export function mapUserModelToDto(model: UserRecordModel): UserRecordDto {
	return {
		...mapBaseModelToBaseDto(model),
		username: model.username ?? null,
		email: model.email ?? null,
		userRoleName: model.userRoleName ?? null,
		userRolePermissions: model.userRolePermissions ?? null,
		lastLoginAt: dateCast(model.lastLoginAt),
		lastLoginIp: model.lastLoginIp ?? null,
		type: model.type ?? null,
	};
}
